import React from 'react';
import { Dialog } from '@reach/dialog';
import PropTypes from 'prop-types';

import ActualButton from '../ActualButton';
import Icon from '../Icon';

import '@reach/dialog/styles.css';
import './style.scss';

const Modal = ({children, className = '', ...props}) => {

	return (
		<Dialog className={`modal__container ${className}`} {...props}>
			{children}
		</Dialog>
	);
};

Modal.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string
};

const TemplateModal = ({children, className = '', onDismiss, isOpen, title, confirmationAction, cancel, confirm, ...props}) => {
	const confirmationActionAndClose = (e) => {
		onDismiss();
		confirmationAction(e);
	};
	return (
		<Dialog className={`modal__container ${className}`} onDismiss={onDismiss} isOpen={isOpen} {...props}>
			<div className='modal__title-container'>

				<h2 className='modal__title-text'>{title}</h2>
				<button className='modal__exit-button' onClick={onDismiss}><Icon>clear</Icon></button>
			</div>
			<div className='modal__content-container'>
				{children}
			</div>
			<div className='modal__buttons-container'>
				{/* this wrapper div is actually necessary for styling */}
				<div>
					{cancel ? <ActualButton onClick={confirmationActionAndClose} cancel>{cancel}</ActualButton> : null }
					{confirm ? <ActualButton onClick={confirmationActionAndClose} confirm>{confirm}</ActualButton> : null }
					<ActualButton onClick={onDismiss}>Cancel</ActualButton>
				</div>
			</div>
		</Dialog>

	);
};

Modal.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string
};

TemplateModal.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	onDismiss: PropTypes.func,
	isOpen: PropTypes.bool,
	title: PropTypes.string,
	confirmationAction: PropTypes.func,
	cancel: PropTypes.string,
	confirm: PropTypes.string
};

export {Modal, TemplateModal};
